<template>
    <div class="index">
        <div class="banner">
            <img alt="" src="@/assets/h5/images/indexbanner.png">
        </div>
        <div class="bgc">
            <div class="box-item">
                <div class="item-title">
                    <span class="more" @click="to('/h5/masses/orgList','',1)">更多<i class="el-icon-arrow-right"></i></span>
                </div>
                <div class="item-list">
                    <p v-for="item in chi" :key="item.id" class="ovHide" @click="showMask(item)">
                        {{ item.org_name }}</p>
                </div>
            </div>

            <div class="box-item zijin">
                <div class="item-title ">
                    <span class="more" @click="to('/h5/masses/orgList','',2)">更多<i class="el-icon-arrow-right"></i></span>
                </div>
                <div class="item-list">
                    <p v-for="item in kai" :key="item.id" class="ovHide" @click="showMask(item)">
                        {{ item.org_name }}</p>
                </div>
            </div>
            <div class="item-flex flex-direction">
                <div class="item-box">
                    <span  class="more center" @click="tip('暂未开放...')">更多<i class="el-icon-arrow-right"></i></span>
                </div>
                <div class="item-box fengxian" @click="tip('暂未开放...')">
                    <span  class="more center">更多<i class="el-icon-arrow-right"></i></span>
                </div>
            </div>
        </div>

        <div class="flex flex-direction">
            <div class="title-box">
                <div class="title-tex">
                    <b>宣传信息</b>
                </div>
                <div class="more" @click="to('/h5/masses/publicizeList','',3)">更多<i class="el-icon-arrow-right"></i></div>
            </div>
            <div class="flex-list">
                <div class="flex-right">
                    <div v-for="item in right" :key="item.id" class="item"
                         @click="to('/h5/masses/detail',item.id,3)">
                        <div class="item-img">
                            <img :src="item.thumb" alt="">
                        </div>
                        <div class="item-cont">
                            <div class="item-title ovHide2">{{ item.title }}</div>

                            <div class="item-time">
                               {{ item.publish_time }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bgc more">
            <div class="item-flex justify-between">
                <div class="item-box flex flex-direction justify-center zhengce" @click="to('/h5/masses/policyList','',1)">
                    <b>政策法规</b>
                    <span>查看更多 +</span>
                </div>
                <div class="item-box flex flex-direction justify-center keji" @click="to('/h5/masses/technologyList','',5)">
                    <b>科技专栏</b>
                    <span>查看更多 +</span>
                </div>
            </div>
        </div>
        <orgDetailDialog :dialogVisible="dialogVisible" :item="item" @handleClose="handleClose"/>
    </div>
</template>
<script>
import {masses_index} from "@/api";
import orgDetailDialog from "@/views/h5/common/orgDetailDialog";
import {loaded, loading, toast} from "@/utils/utils";

export default {
    name: "index",
    data() {
        return {
            dialogVisible: false,
            item: {},
            chi: [],
            kai: [],
            one: [],
            right: []
        }
    },
    components: {orgDetailDialog},
    created() {
        this.init()
    },
    methods: {
        async init() {
            loading()
            let _data = await masses_index();
            loaded()
            if (_data.status == 200) {
                this.chi = _data.data.chi;
                this.kai = _data.data.kai;
                this.one = _data.data.one;
                _data.data.right.unshift(_data.data.one)
                this.right = _data.data.right
            }
        },
        to(path, id, type) {
            this.$router.push({
                path: path,
                query: {
                    id: id,
                    type: type
                }
            })
        },
        tip(msg){
            toast(msg)
        },
        showMask(item) {
            this.item = item;
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false
            this.item = {}
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.index {
    .flex-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 6.3vw;

        .flex-right {
            //width: 738px;
            //height: 705px;
            //overflow-y: hidden;
            width: 100%;
            padding:  0 3.5vw;
            .item {
                width: 100%;
                background-image: linear-gradient(0deg,
                    #ffffff 0%,
                    #f0f7ff 100%);
                box-shadow: 0.7vw 0.5vw 2.1vw 0vw
                rgba(0, 46, 108, 0.19);
                border-radius: 8px;
                border: solid 1px #ffffff;
                padding: 4vw;
                display: flex;
                justify-content: flex-start;
                margin-bottom: 2.7vw;

                &:nth-child(3n) {
                    margin-bottom: 0;
                }

                .item-cont {
                    flex: 1;
                    width: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .item-title {
                        width: 100%;
                        font-size: 3.7vw;
                        font-weight: 600;
                        line-height: 5.9vw;
                        color: #141c24;
                    }

                    .item-time {
                        font-size: 3.2vw;
                        color: #9c9fa2;
                    }
                }

                .item-img {
                    width: 28.5vw;
                    height: 20vw;
                    border-radius: 1.3vw;
                    margin-right: 3.5vw;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 1.3vw;
                    }
                }
            }
        }

        .flex-left {
            width: 736px;
            height: 705px;
            background-image: linear-gradient(0deg,
                #ffffff 84%,
                #eff7ff 100%);
            box-shadow: 11px 8px 18px 0px rgba(0, 46, 108, 0.17);
            border-radius: 8px;
            border: solid 1px #ffffff;
            padding: 25px 30px;

            .left-title {
                width: 100%;
                font-size: 18px;
                color: #0d7bff;
            }

            .left-more {
                width: 110px;
                height: 38px;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #4698fb;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #4698fb;
                font-size: 14px;
                margin-top: 45px;
                cursor: pointer;

                i {
                    font-size: 18px;
                    color: #4698fb;
                    margin-left: 10px;
                }
            }

            .left-time {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                color: #999999;
                padding: 15px 0;

                i {
                    font-size: 20px;
                    color: #999999;
                    margin-right: 10px;
                }
            }

            .left-img {
                width: 100%;
                height: 446px;
                border-radius: 8px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;
                }
            }
        }

        .flex-right {
        }
    }

    .title-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 3.9vw 7.2vw;


        .more {
            font-size: 3.5vw;
            color: #333;
            cursor: pointer;
        }

        .title-tex {
            b {
                display: block;
                font-size: 4vw;
                color: #4698fb;
                font-weight: bold;
            }
        }
    }

    .bgc {
        width: 100%;
        background: #ebf4ff;
        border-radius: 4.4vw 4.4vw 0vw 0vw;
        border: solid 1px #ffffff;
        margin-top: -4vw;
        padding: 5.6vw 3.5vw;
        position: sticky;
        z-index: 1;
        &.more{
            margin-top: 0;
            border: none;
            border-radius: 0;
            padding: 4vw;
        }
        .item-flex {
            width: 100%;
            display: flex;

            .item-box {
                width: 100%;
                height: 12.5vw;
                background: url("../../../assets/h5/images/xingjititle.png") no-repeat;
                background-size: 100% 100%;
                border-radius: 2.7vw;
                border: solid 0.3vw #ffffff;
                margin-top: 2.5vw;
                position: relative;
                .more {
                    position: absolute;
                    font-size: 3.5vw;
                    right: 3.2vw;
                    top: 3.5vw;
                    color: #333;
                    cursor: pointer;
                    &.center {
                        top: 1.7vw;
                    }
                }
                &.zhengce {
                    background: url("../../../assets/h5/images/zhengfatitle.png") no-repeat;
                    background-size: 100% 100%;
                    padding-left: 4.3vw;
                    width: 45.5vw;
                    height: 19.6vw;

                }

                &.keji {
                    background: url("../../../assets/h5/images/kejititle.png") no-repeat;
                    background-size: 100% 100%;
                    padding-left: 4.3vw;
                    width: 45.5vw;
                    height: 19.6vw;
                }

                &.fengxian {
                    background: url("../../../assets/h5/images/fengxiantitle.png") no-repeat;
                    background-size: 100% 100%;
                }

                b{
                    font-size: 4.5vw;
                    font-weight: 600;
                    color: #ffffff;
                }

                span{
                    font-size: 3.2vw;
                    color: #ffffff;
                    margin-top: 2vw;
                }

            }
        }

        .box-item {
            width: 100%;
            background-image: linear-gradient(0deg,
                #e7fdff 0%,
                #f6feff 100%);
            border-radius: 2.7vw;
            border: solid 0.3vw #ffffff;

            .item-list {
                width: 100%;
                padding: 4vw;
                display: flex;
                flex-direction: column;


                p {
                    width: 100%;
                    height: 7.1vw;
                    background-color: #ffffff;
                    box-shadow: 0vw 0vw 2.1vw 0vw
                    rgba(7, 65, 149, 0.05);
                    border-radius: 1.3vw;
                    padding: 0 3.7vw;
                    line-height: 7.1vw;
                    font-size: 3.7vw;
                    color: #2c2c2c;
                    cursor: pointer;
                    & + p{
                        margin-top: 1.3vw;
                    }
                }
            }

            .item-title {
                width: 100%;
                height: 17.2vw;
                background: url("../../../assets/h5/images/jigoutitle.png") no-repeat;
                background-size: 100% auto;
                position: relative;
                .more {
                    position: absolute;
                    font-size: 3.5vw;
                    right: 3.2vw;
                    top: 3.5vw;
                    color: #333;
                    cursor: pointer;
                }
            }

            &.zijin {
                background-image: linear-gradient(0deg,
                    #e1eeff 0%,
                    #ffffff 100%);
                box-shadow: 11px 8px 18px 0px rgba(0, 46, 108, 0.17);
                margin-top: 2.5vw;

                .item-title {
                    height: 12.5vw;
                    background: url("../../../assets/h5/images/zijintitle.png") no-repeat;
                    background-size: 100% auto;
                }

                .item-list {
                    span {
                        color: #67aeff;
                    }
                }
            }
        }
    }

    .banner {
        width: 100%;

        img {
            width: 100%;
            height: auto;
        }
    }
}
</style>


